import { useEffect, useState } from "react";
import { useInView } from "../../hooks/useInView";

export default function AnimatedCounter({ end, suffix = "", duration = 2000, label }) {
  const [ref, inView] = useInView();
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let start = 0;
    const step = Math.ceil(end / (duration / 16));
    const timer = setInterval(() => {
      start += step;
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(start);
      }
    }, 16);
    return () => clearInterval(timer);
  }, [inView, end, duration]);

  return (
    <div ref={ref} className="text-center">
      <div className="text-4xl md:text-5xl font-bold text-white tabular-nums">
        {count}
        {suffix}
      </div>
      {label && <p className="mt-2 text-sm text-white/60 uppercase tracking-widest">{label}</p>}
    </div>
  );
}
